import { offline } from '@carrent/platform'

import { chatHandlers } from './chatTasks'
import { tripHandlers } from './tripTasks'

/**
 * Единый запуск очереди устройства.
 *
 * worker.start заменяет обработчики целиком, поэтому регистрация
 * по частям (сначала поездки, потом чат) молча выключила бы первое.
 * Все типы задач собираются здесь — и только здесь.
 */
export function startDriverQueue(callbacks) {
  return offline.worker.start({
    ...tripHandlers(callbacks),
    ...chatHandlers(callbacks),
  })
}
